import storageAvailable from 'storage-available';
import {doAjax} from 'surveylabJsAssets/common/_ajax';
import SentryHelper from 'surveylabJsAssets/sentry/_sentry-helper';
import {SeverityLevel} from "@sentry/browser";
import {Modal} from "bootstrap";
import AssessmentHelper from '../common/_assessment-helper';

// noinspection JSUnusedGlobalSymbols
// todo remove
export default function () {
  const sourceSelect = document.getElementById('item-id-205') as HTMLSelectElement | null;
  const sourceSelectSecondary = document.getElementById('item-id-230') as HTMLSelectElement | null;
  const targetContainer = document.querySelector('.survey-item-240') as HTMLElement | null;
  const targetOuterContainer = document.querySelector('.survey-element-container-240') as HTMLElement | null;
  const skippedIdsInput = document.querySelector('input[name="hidden-client-side-skipped-item-ids"]') as HTMLInputElement | null;
  const targetChildren = targetContainer
    ? Array.from(targetContainer.querySelectorAll(':scope > div > div')) as HTMLElement[]
    : [];

  if (!sourceSelect || !sourceSelectSecondary || !targetContainer || !targetOuterContainer || !skippedIdsInput || targetChildren.length === 0) {
    return;
  }

  const displayMap: Record<string, number[]> = {
    '1': [9, 10, 11],  // BE
    '2': [1, 2, 3],    // FR
    '3': [4, 5, 6],    // GE
    '6': [7, 8],       // VD
  };

  const updateTargetOptions = (clearSelection: boolean) => {
    const selectedValue = sourceSelect.value;
    const allowDisplay = sourceSelectSecondary.value === '1';
    const showIndexes = new Set(allowDisplay ? (displayMap[selectedValue] || []) : []);

    if (clearSelection || showIndexes.size === 0) {
      targetContainer.querySelectorAll('input[type="radio"]').forEach((radio) => {
        (radio as HTMLInputElement).checked = false;
      });
    }

    targetChildren.forEach((child, index) => {
      const oneBasedIndex = index + 1;
      child.hidden = !showIndexes.has(oneBasedIndex);
    });

    const shouldHideOuter = showIndexes.size === 0;
    targetOuterContainer.hidden = shouldHideOuter;

    const currentIds = skippedIdsInput.value
      .split(';')
      .map((id) => id.trim())
      .filter((id) => id.length > 0);
    const hasId240 = currentIds.includes('240');

    if (shouldHideOuter && !hasId240) {
      skippedIdsInput.value = [...currentIds, '240'].join(';');
    } else if (!shouldHideOuter && hasId240) {
      skippedIdsInput.value = currentIds.filter((id) => id !== '240').join(';');
    }
  };

  sourceSelect.addEventListener('change', () => updateTargetOptions(true));
  sourceSelectSecondary.addEventListener('change', () => updateTargetOptions(false));
  updateTargetOptions(false);
}
